module.exports = __webpack_public_path__ + "img/redeem-voucher-code.10031c78.png";